export default "__VITE_ASSET__37a2b78c__"